( function () {
	'use strict';

	function createSchedule ( ) {
		return {
			'templateUrl'      : '/templates/schedules/create-schedule/create-schedule.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'CreateSchedCtrl',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'events'   : '=',
				'fetching' : '='
			}
		};
	}

	angular
		.module( 'app.schedules' )
		.directive( 'createSchedule', createSchedule )
		.run( [
			'$rootScope', '$modalStack',
			function ( $rootScope, $modalStack ) {
				$rootScope.$on( '$locationChangeStart', function ( event, next, current ) {
					var top = $modalStack.getTop();

					if ( top ) {
						$modalStack.dismiss( top.key );
						event.preventDefault();
						if ( current.indexOf( 'template/' ) > -1 || current.indexOf( 'observations/' ) > -1 ) {
							$rootScope.$broadcast( 'obs:get:groups:noparam', true );
						}
					}
				} );
			}
		] );
} )( );
